// src\services\ChatService.js

import axios from 'axios';
import { ChatModelStrategy } from './ChatStrategies';

const saveChatLog = async (chatLog, url) => {
  try {
    const response = await fetch(`${url}/saveChatLog`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(chatLog),
    });
    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.message || 'Failed to save chat log.');
    console.log('Chat log saved successfully.');
  } catch (error) {
    console.error('Error saving chat log:', error);
  }
};

class ChatService {
  constructor(modelStrategy) {
    if (!(modelStrategy instanceof ChatModelStrategy)) {
      throw new Error('Invalid model strategy provided.');
    }
    this.modelStrategy = modelStrategy;
  }

  async fetchResponse(input, modelSettings) {
    return this.modelStrategy.fetchResponse(input, modelSettings);
  }

  static async saveChatLog(chatLog) {
    return saveChatLog(chatLog, process.env.REACT_APP_BACKEND_URL);
  }

  static async getAllChatLogs(username) {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/getAllChatLogs`, {
        params: {
          username: encodeURIComponent(username),
        },
      });
      return { success: true, chatLogs: response.data };
    } catch (error) {
      return { success: false, message: error.message };
    }
  }
}

export { ChatService, saveChatLog };
